
const state = {
    skin_info: {
        backgroundColor: '#404040',
        color: '#FFFFFF'
    },
    set_skin_info_style: '1'
}
// 初始化state
if (localStorage['set_skin_info_style']) {
    state.set_skin_info_style = localStorage['set_skin_info_style']
}
const mutations = {
    set_skin_info (state, data) {
        state.skin_info = data
    },
    set_skin_info_style (state, data) {
        state.set_skin_info_style = data
        localStorage['set_skin_info_style'] = data
    }
}
const getters = {
    get_skin_info: state => state.skin_info
}
export default {
    state,
    getters,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/theme.js